(() => {
  if (customElements.get('tr-planner-flipbook')) return;
  class PlannerFlipbook extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.previews = JSON.parse(this.querySelector('[data-previews]').textContent).filter(p => p.pages.length);
      if (!this.previews.length) return;
      this.optionNames = JSON.parse(this.querySelector('[data-options]').textContent);
      this.scope = this.closest('[data-section-type="product"]') || this.parentElement;
      this.defaults = {heading:this.querySelector('[data-heading]').textContent,subheading:this.querySelector('[data-subheading]').textContent,description:this.querySelector('[data-description]').innerHTML,background:this.style.getPropertyValue('--tr-flip-bg')};
      this.media = matchMedia('(max-width:749px)');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const select = this.querySelector('[data-format]');
      select.replaceChildren();
      this.previews.forEach((p,i) => select.add(new Option(p.label || `Preview ${i+1}`,String(i))));
      this.querySelector('.tr-format').hidden = this.previews.length < 2;
      this.addEventListener('click',e => {
        const b = e.target.closest('button'); if (!b) return;
        if (b.hasAttribute('data-prev')) this.turn(-1);
        if (b.hasAttribute('data-next')) this.turn(1);
        if (b.hasAttribute('data-enlarge')) { this.querySelector('dialog').showModal(); this.paint(); }
        if (b.hasAttribute('data-close')) this.querySelector('dialog').close();
      },{signal});
      this.addEventListener('keydown',e => {
        if (e.target.matches('select,input,textarea')) return;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {e.preventDefault();this.turn(e.key === 'ArrowLeft' ? -1 : 1);}
      },{signal});
      select.addEventListener('change',()=>this.choose(Number(select.value)),{signal});
      this.scope.addEventListener('change',e => {
        if (this.contains(e.target)) return;
        const names=this.previews.map(p=>this.normal(p.optionName));
        if(e.target.hasAttribute('data-index') || names.includes(this.normal(e.target.name)) || names.includes(this.normal((e.target.name || '').replace(/^properties\[/,'').replace(/\]$/,''))))this.sync();
      },{signal});
      this.observer = new MutationObserver(records => {
        if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1 && !this.contains(n) && (n.matches('input,select') || n.querySelector('input,select')))))this.sync();
      });
      this.observer.observe(this.scope,{childList:true,subtree:true});
      this.resize = () => {this.page = Math.floor(this.page / this.step()) * this.step();this.paint();};
      this.media.addEventListener('change',this.resize);
      let start;
      const spread = this.querySelector('.tr-spread');
      spread.addEventListener('touchstart',e=>{start={x:e.changedTouches[0].clientX,y:e.changedTouches[0].clientY};},{passive:true,signal});
      spread.addEventListener('touchend',e=>{if(!start)return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;if(Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy))this.turn(dx<0?1:-1);start=null;},{passive:true,signal});
      this.choose(0); this.sync(); this.hidden = false;
    }
    disconnectedCallback(){if(this.controller)this.controller.abort();if(this.observer)this.observer.disconnect();if(this.media)this.media.removeEventListener('change',this.resize);this.ready=false;}
    step(){return this.media.matches ? 1 : 2;}
    normal(s){return String(s || '').trim().toLowerCase();}
    sync(){
      const matched = this.previews.findIndex(p => {
        if(!p.optionName || !p.optionValue)return false;
        const index = this.optionNames.findIndex(n=>this.normal(n)===this.normal(p.optionName));
        let fields;
        if(index>=0)fields=[...this.scope.querySelectorAll(`[data-index="option${index+1}"]`)];
        else fields=[...this.scope.querySelectorAll('input[name],select[name],textarea[name]')].filter(el=>this.normal(el.name)===this.normal(p.optionName) || this.normal(el.name)===this.normal(`properties[${p.optionName}]`));
        return fields.some(el=>(!['radio','checkbox'].includes(el.type)||el.checked) && this.normal(el.value)===this.normal(p.optionValue));
      });
      const fallback = this.previews.findIndex(p=>!p.optionName && !p.optionValue);
      const next=matched>=0?matched:(fallback>=0?fallback:0);
      if(next!==this.active)this.choose(next);
    }
    choose(index){
      this.active=index;this.page=0;const p=this.previews[index];
      this.querySelector('[data-format]').value=String(index);
      ['heading','subheading'].forEach(k=>{const el=this.querySelector(`[data-${k}]`);el.textContent=p[k] || this.defaults[k];el.hidden=!el.textContent;});
      const desc=this.querySelector('[data-description]');
      if(p.description){desc.textContent=p.description;desc.style.whiteSpace='pre-line';}else{desc.innerHTML=this.defaults.description;desc.style.whiteSpace='';}
      this.style.setProperty('--tr-flip-bg',p.background || this.defaults.background);this.paint();
    }
    turn(direction){const max=Math.floor((this.previews[this.active].pages.length-1)/this.step())*this.step();this.page=Math.max(0,Math.min(max,this.page+direction*this.step()));this.paint(true);}
    paint(animate=false){
      const pages=this.previews[this.active].pages, end=Math.min(pages.length,this.page+this.step());
      [this.querySelector('.tr-spread'),this.querySelector('.tr-large-spread')].forEach(spread=>{
        spread.replaceChildren();pages.slice(this.page,end).forEach((p,i)=>{const img=new Image();img.src=p.src;img.alt=`${p.alt}, page ${this.page+i+1}`;img.width=p.width || 700;img.height=p.height || 900;img.decoding='async';spread.append(img);});
        if(animate){spread.classList.remove('tr-page-turn');void spread.offsetWidth;spread.classList.add('tr-page-turn');}
      });
      const status=end===this.page+1?`Page ${end} of ${pages.length}`:`Pages ${this.page+1}–${end} of ${pages.length}`;
      this.querySelector('[data-status]').textContent=status;this.querySelector('[data-large-status]').textContent=status;
      this.querySelectorAll('[data-prev]').forEach(b=>b.disabled=this.page===0);this.querySelectorAll('[data-next]').forEach(b=>b.disabled=end===pages.length);
    }
  }
  customElements.define('tr-planner-flipbook',PlannerFlipbook);
})();
